import { MemorialTheme } from "apiEndPoints";
import APIrequest from "services/axios";
import { logger } from "utils";

export const ThemeService = {
  PreviewImageService: async (bodyData, memorialId, token) => {
    try {
      const payload = {
        ...MemorialTheme.savePreviewImage(memorialId),
        bodyData,
        token,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  ReportMemorialService: async (bodyData) => {
    try {
      const payload = {
        ...MemorialTheme.reportMemorial,
        bodyData,
      };
      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },
  updateCommentStatus: async ({ id, bodyData }) => {
    try {
      const payload = {
        ...MemorialTheme.updateCommentStatus(id),
        bodyData,
      };
      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },

  GetReportCategoryService: async () => {
    try {
      const payload = {
        ...MemorialTheme.getReportCategory,
      };
      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },
  GetLocationService: async (id) => {
    try {
      const payload = {
        ...MemorialTheme.getLocations(id),
      };
      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },
  saveUnSaveBiographyService: async (memorialId) => {
    try {
      const payload = {
        ...MemorialTheme.saveUnSaveBiography(memorialId),
      };
      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },

  getFamilyTreeService: async (memorialId) => {
    try {
      const payload = {
        ...MemorialTheme.getFamilyTree(memorialId),
      };
      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },

  getScreenShotService: async (memorialId) => {
    try {
      const payload = {
        ...MemorialTheme.getScreenShot(memorialId),
      };
      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },

  getPaternalTreeService: async (memorialId) => {
    try {
      const payload = {
        ...MemorialTheme.getPaternalTree(memorialId),
      };
      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },
};
